import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import makeOfferLauncher from 'dibs-buyer-layout/exports/makeOfferLauncher';
import ArrowRightIcon from 'dibs-vg/dist/react/arrow-right';
import tracking from 'dibs-tracking';
import CartButton from './CartButton';

import styles from './styles/CartMakeOfferButton.scss';

function CartMakeOfferButton({ trackingLabel, item, currency, relay, quantitySelected }) {
    return (
        <CartButton
            type="secondary"
            dataTn="item-actions-make-offer"
            onClick={() => {
                tracking.trackEvent({
                    action: 'cart make offer button',
                    category: 'make offer click',
                    label: trackingLabel,
                });
                tracking.trackEcommerce({
                    type: 'addToCart',
                    products: [item.ecommerceTrackingParams],
                });

                makeOfferLauncher({
                    currency,
                    itemId: item.serviceId,
                    environment: relay.environment,
                    quantitySelected,
                    launchOrigin: 'cart',
                });
            }}
        >
            <FormattedMessage id="CartMakeOfferButton.makeOffer" defaultMessage="Make An Offer" />
            <ArrowRightIcon className={styles.arrow} />
        </CartButton>
    );
}

CartMakeOfferButton.propTypes = {
    relay: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    trackingLabel: PropTypes.string.isRequired,
    currency: PropTypes.string,
    quantitySelected: PropTypes.string,
};

export default createFragmentContainer(CartMakeOfferButton, {
    user: graphql`
        fragment CartMakeOfferButton_user on User {
            isVerifiedTrade
        }
    `,
    item: graphql`
        fragment CartMakeOfferButton_item on Item {
            serviceId
            ecommerceTrackingParams
        }
    `,
});
